export default {
  getOwnerGroup: '/manage/user/getOwnerGroup',
  updateOwnerGroup: '/manage/user/updateOwnerGroup',
  getList: '/manage/locationRelation/findList',
  delete: '/manage/locationRelation/delete',
  find: '/manage/locationRelation/find',
  update: '/manage/locationRelation/update',
  save: '/manage/locationRelation/save'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/coowner.js